import React, { useMemo } from "react"
import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material"
import { capitalize } from "lodash"

import { getIcon } from "utils/icon"

import { useTranslation } from "providers/i18n"
import { useEvent } from "hooks/event/useEvent"
import { PageLayout } from "layouts/PageLayout"

import { VerticalEventCard } from "components/domains/events"
import { Head } from "components/Head"
import { EmptyData } from "components/EmptyData"
import { CalendarStarIcon } from "components/icons"
import { Link } from "react-router-dom"

export const Events = ({ Layout = PageLayout, AppNavigation }) => {
  const { t } = useTranslation()
  const { groupEvents, activeGroupEvent, handleChange, events } = useEvent()
  const activeEvents = groupEvents[activeGroupEvent]

  const theme = useTheme()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.events) || <CalendarStarIcon />,
    [theme]
  )

  const { styleOverrides } = theme.components?.[`EventPage`] || {}

  //Todo: refactor code to config layout by appConfig
  const { eventSeparatedOption } =
    theme.components?.[`PromotionPage`]?.defaultProps || {}

  const {
    root,
    gridContainer,
    emptyDataWrapper,
    eventGroupSelectorButton,
    toggleButtonGroup,
    toggleButton,
    pageLayout,
  } = styleOverrides

  return (
    <>
      <Head title={t("Events & Activities")} />
      <Layout sx={pageLayout} AppNavigation={AppNavigation}>
        <Box sx={root}>
          {eventSeparatedOption ? (
            <>
              <Box sx={eventGroupSelectorButton}>
                <ToggleButtonGroup
                  value={activeGroupEvent}
                  onChange={handleChange}
                  exclusive
                  sx={toggleButtonGroup}
                >
                  <ToggleButton value="current" sx={toggleButton}>
                    {t("Current Events")}
                  </ToggleButton>
                  <ToggleButton value="upcoming" sx={toggleButton}>
                    {t("Upcoming Events")}
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
              {activeEvents && activeEvents.length > 0 ? (
                <Box sx={gridContainer}>
                  {activeEvents.map((event) => {
                    const sponsoredId = event?.properties?.sponsoredId
                    return (
                      <Link
                        to={`/events/${event.id}`}
                        key={`${sponsoredId || ""}${event.id}`}
                      >
                        <VerticalEventCard event={event} />
                      </Link>
                    )
                  })}
                </Box>
              ) : (
                <Box sx={emptyDataWrapper}>
                  <EmptyData
                    icon={emptyIcon}
                    primary={t(`No ${capitalize(activeGroupEvent)} Events`)}
                    secondary={t("Check Back Soon")}
                  />
                </Box>
              )}
            </>
          ) : (
            <>
              {events && events.length > 0 ? (
                <Box sx={gridContainer}>
                  {events.map((event) => {
                    const sponsoredId = event?.properties?.sponsoredId
                    return (
                      <Link
                        to={`/events/${event.id}`}
                        key={`${sponsoredId || ""}${event.id}`}
                      >
                        <VerticalEventCard event={event} />
                      </Link>
                    )
                  })}
                </Box>
              ) : (
                <Box sx={emptyDataWrapper}>
                  <EmptyData
                    icon={emptyIcon}
                    primary={t(`Coming soon`)}
                    secondary={t("Stay tuned for the update")}
                  />
                </Box>
              )}
            </>
          )}
        </Box>
      </Layout>
    </>
  )
}
